import React, {memo} from 'react';
import ChatView from './chatview';
import {useQuery} from 'react-query';
import {ActivityIndicator} from 'react-native-paper';
import {useRouteContact} from '../../hooks/useRouteContact';
import {useRoute} from '@react-navigation/native';
import {getById, getFolderContent, getUserData} from '../../api';
import {Contact, FolderType, UserInfo} from '../../types';
import {ChatParams} from '../../types/nav';
import {useFolder} from '../../hooks/useFolder';
import {View, useWindowDimensions} from 'react-native';
import {FolderNavigator} from '../folder/foldernavigator';
import ContentItem from '../folder/items/contentitem';
import {styles} from './styles';

function Chat({
  isEmbed,
  params,
  height,
}: {
  isEmbed?: boolean;
  params: ChatParams;
  height?: number;
}) {
  const chatId = params.chatId;
  const userQuery = useQuery('UserData', () => getUserData(), {
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    onError(err) {
      console.error('on get contact error', err);
    },
  });
  const contactQuery = useQuery(
    'contact_' + chatId,
    () => getById(chatId),
    {
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      onError(err) {
        console.error('on get contact error', err);
      },
    },
  );
  const isLoading = !userQuery.isFetched || !contactQuery.isFetched;
  const contact = contactQuery?.data as Contact;
  const user = userQuery?.data as UserInfo;
  const dim = useWindowDimensions();
  const {width} = dim;
  const parentFolderId =
    params?.parentFolderId ||
    params?.parentFolderId! ||
    ((contact && contact.folderId) as string);
  const parentFolderHook = useFolder(
    parentFolderId,
    getFolderContent,
    getById,
    FolderType.contact,
  );

  useRouteContact(contact, isLoading, user, params);
  const isMobile = width > 700 && !isEmbed ? false : true;
  return (
    <View
      style={{
        width: '100%',
        height: '100%',
        flexDirection: 'row',
        backgroundColor: 'black',
      }}>
      {!isMobile ? (
        <FolderNavigator
          folderType={FolderType.contact}
          renderContent={({item}) => (
            <ContentItem
              i={item}
              key={item.id}
              dataHook={parentFolderHook}
              styles={styles}
              width={!isMobile ? (width / 100) * 30 : width}
            />
          )}
          parentFolderId={parentFolderId}
          parentFolderHook={parentFolderHook}
        />
      ) : null}
      <View
        style={{width: isMobile ? '100%' : '70%', height: 'auto'}}>
        <ChatView
          params={{user, contact}}
          chatId={chatId}
          height={height}
          isEmbeded={isEmbed}
          queryParams={params}
        />
      </View>
    </View>
  );
}

export default memo(Chat);
